export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6903.58015b8e.jpg";